import React from 'react';
import { SketchPicker } from 'react-color';
import './ColorPicker.css';

const PRESET_COLORS = [
  '#D0021B',
  '#F5A623',
  '#F8E71C',
  '#8B572A',
  '#7ED321',
  '#417505',
  '#BD10E0',
  '#9013FE',
  '#4A90E2',
  '#50E3C2',
  '#B8E986',
  '#000000',
  '#4A4A4A',
  '#9B9B9B',
  '#FFFFFF',
  'transparent'
];

export class ColorPicker extends React.Component {
  constructor(props) {
    super();
    this.state = {
      displayColorPicker: false
    };
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  render() {
    return (
      <div className="ColorPicker">
        <div
          style={{ backgroundColor: this.props.color }}
          className="ColorPicker_Rectangle"
          onClick={this.handleClick}
        >
          <span>{this.props.title}</span>
        </div>

        {this.state.displayColorPicker ? (
          <div className="ColorPicker__Popover">
            <div className="ColorPicker__Cover" onClick={this.handleClose} />
            <SketchPicker
              color={this.props.color}
              disableAlpha
              presetColors={PRESET_COLORS}
              onChangeComplete={this.props.onChangeComplete || (() => {})}
            />
          </div>
        ) : null}
      </div>
    );
  }
}
